import { Navigate, useLocation } from 'react-router';
import type { ReactNode } from 'react';
import { useAuth } from './AuthContext';

interface Props {
  children: ReactNode;
}

export function ProtectedRoute({ children }: Props) {
  const { isAuthenticated, isLoading, user } = useAuth();
  const location = useLocation();

  if (isLoading) {
    return (
      <div
        style={{
          minHeight: '100dvh',
          display: 'grid',
          placeItems: 'center',
          fontFamily: 'var(--hm-mono)',
          color: 'var(--text-muted)',
          letterSpacing: '0.04em',
          fontSize: 12,
          textTransform: 'uppercase',
        }}
      >
        verifying session
      </div>
    );
  }

  if (!isAuthenticated) {
    const next = encodeURIComponent(location.pathname + location.search);
    return <Navigate to={`/login?next=${next}`} replace />;
  }

  // An external travel agent has exactly one screen: the Agent Portal. Every
  // staff route (the hub home, the Dock, My Notes, …) sends them back there.
  // This is navigation only — the API refuses every other endpoint to an
  // agent token anyway (AgentScopeMiddleware).
  if (user?.role === 'agent') {
    return <Navigate to="/agent" replace />;
  }

  return <>{children}</>;
}
